const incidentReporting = (() => {
  let reportingTable, reportingData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Reporting
  //-------------------------------------------------------------------------------

  function getIncidentReportingView() {
    const frag = document.createDocumentFragment();
    
    reportingTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Category'],
      endIcon: true,
    });

    const headers = reportingTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addReportingBtnDiv = document.createElement('div');
    const addReportingBtn = new Button({
      text: 'ADD NEW REPORTING CATEGORY',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(reportingTable);
    if ($.session.SetupInsert) {
      addReportingBtn.button.style.float = 'right';
      addReportingBtn.renderTo(addReportingBtnDiv);
      frag.append(addReportingBtnDiv);
    }

    const tableReportingData = reportingData
      .map(p => {
        return {
          values: [p.reportingName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showReportingPopup(p);
          },
          endIconCallback: () => handleReportingDelete(p),
        };
      });

    table.populate(reportingTable, tableReportingData);
    table.sortTableByHeader(reportingTable);

    addReportingBtn.onClick(e => {
      showReportingPopup();
    });

    return frag;
  }

  // Incident Reporting
  //-------------------------------------------------------------------------------

  function showReportingPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const reportingForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Category',
          id: 'cName',
          required: true,
        },
      ],
    });

    reportingForm.onKeyup(() => {
      reportingForm.inputs['cName'].setValidtyError('');
      reportingForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(reportingForm);
    });
    reportingForm.onChange(event => {
      reportingForm.inputs['cName'].setValidtyError('');
      reportingForm.inputs['cName'].clearErrorOrWarning();
      checkForRequiredFields(reportingForm);
    });

    reportingForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentReportingData', {
          id: rowData ? rowData.reportingId : 0,
          reportingName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentReportingDataResult;
      const newID = resp.reportingId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This reporting category already exists.', reportingForm);
        reportingForm.buttons['submit'].toggleDisabled(true);
        reportingForm.buttons['cancel'].toggleDisabled(true);
      } else {
        reportingForm.clear();
        POPUP.hide(popup);
        await getReportingData();
        updateReportingTable();
      }
    });

    reportingForm.onCancel(event => {
      reportingForm.clear();
      reportingForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    reportingForm.renderTo(popup);

    POPUP.show(popup);

    reportingForm.populate({
      cName: rowData ? rowData.reportingName : '',
    });

    reportingForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      reportingForm.disableFormInputs();
    }
  }

  async function handleReportingDelete(row) {
    const rowData = reportingData.find(a => a.reportingId == row.reportingId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This reporting category is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this reporting category?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentReportingData', {
            token: $.session.Token,
            reportingId: row.reportingId,
          });

          await getReportingData();
          updateReportingTable();
        }
      });
    }
  }
  function updateReportingTable() {
    const tableReportingData = reportingData
      .map(p => {
        return {
          values: [p.reportingName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showReportingPopup(p);
          },
          endIconCallback: () => handleReportingDelete(p),
        };
      });

    table.populate(reportingTable, tableReportingData);
  }

  async function getReportingData() {
    const dataReporting = await _UTIL.fetchData('getIncidentReporting');
    reportingData = dataReporting.getIncidentReportingResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getReportingData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Reporting';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Reporting') {
      viewMarkup = getIncidentReportingView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
